import React from 'react';
import styled from 'styled-components';
import Typography from './Typography';

const Chip = ({
  category,
  isActive,
  onClick,
  icon,
  iconSize = '24px'
}) => {
  return (
    <Option $isActive={isActive} onClick={onClick}>
      {icon && <StyledIcon $size={iconSize}>{icon}</StyledIcon>}
      <CategoryTitle
        as="p"
        $isActive={isActive}
        $variant="body-2-semibold"
      >
        {category}
      </CategoryTitle>
    </Option>
  );
};

export default Chip;


const Option = styled.div`
  cursor: pointer;
  border: 1px solid ${({ $isActive, theme }) => ($isActive ? theme.border.brandMain : theme.border.defaultWeak)};
  border-radius: ${({ theme }) => theme.sizing.lg};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: ${({ theme }) => theme.sizing.xxs};
  padding: ${({ theme }) => theme.sizing.xs} ${({ theme }) => theme.sizing.sm};
  transition: all 0.3s;

  &:hover {
    border: 1px solid ${({ $isActive, theme }) => ($isActive ? theme.border.brandMain : theme.border.defaultWeak)};
    background-color: ${({ $isActive, theme }) => ($isActive ? theme.fill.brandAlphaMain16 : theme.fill.defaultWeak)};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => theme.sizing.xxs} 12px;
  }
`;

const CategoryTitle = styled(Typography)`
  color: ${({ $isActive, theme }) => ($isActive ? theme.colors.brandMain : theme.colors.defaultSubtle)};
`;

const StyledIcon = styled.span`
  width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};

  svg {
    width: ${({ $size }) => $size};
    height: ${({ $size }) => $size};
  }

`;